import H from 'constants/httpMethod.const';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beKpiCsv'); // eslint-disable-line no-unused-vars

const MISSING = 'Missing one or more of the required parameters';

const reconfigure = (config) => (options, extra) => {
  const bgn = fromAnyDateToIso(extra?.bgn) || null;
  const end = fromAnyDateToIso(extra?.end) || null;

  const params = { bgn, end };

  if (!bgn || !end) {
    L.warn('reconfigure()', options?.name, MISSING, params, 'for', { config, options, extra });
  }

  return {
    ...options,
    ...config,
    params,
  };
};

export const ibeKpiCsvRead = actionEndpointBe(
  'ibeKpiCsvRead',
  H.get,
  'metrics/kpi/stylists/performance/export/:salonId/:bgn/:end/',
  reconfigure({ inert: true }),
);

export const abeKpiCsvRead = actionEndpointBe(
  'abeKpiCsvRead',
  H.get,
  'metrics/kpi/stylists/performance/export/:salonId/:bgn/:end/',
  reconfigure({ inert: false }),
);
